import { api } from '../api';

const getVehicleActivityLogs = async ({
  pageNumber = 1,
  pageSize = 10,
  customerId = null,
  filter = null,
}) => {
  const data = {
    page: pageNumber,
    pageSize,
    customerId,
    filter,
  };
  const response = await api({
    url: `Vehicles/GetVehicleActivityLogs`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data,
    params: null,
  });
  return response.data;
};

const demandServices = {
  getVehicleActivityLogs,
};

export default demandServices;
